import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCriticalWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.0312 4.21002C10.4483 4.21002 10.7864 4.54815 10.7864 4.96524V11.0069C10.7864 11.424 10.4483 11.7622 10.0312 11.7622C9.61414 11.7622 9.276 11.424 9.276 11.0069V4.96524C9.276 4.54815 9.61414 4.21002 10.0312 4.21002Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0382 14.0278C11.0382 14.584 10.5874 15.0348 10.0312 15.0348C9.4751 15.0348 9.02429 14.584 9.02429 14.0278C9.02429 13.4717 9.4751 13.0209 10.0312 13.0209C10.5874 13.0209 11.0382 13.4717 11.0382 14.0278Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.64669 0.370991C9.5034 -0.123664 10.559 -0.123664 11.4158 0.370991L17.6779 3.98643C18.5346 4.48108 19.0625 5.39525 19.0625 6.38455V13.6154C19.0625 14.6048 18.5346 15.5189 17.6779 16.0135L11.4158 19.629C10.559 20.1237 9.5034 20.1237 8.64669 19.629L2.38456 16.0135C1.52778 15.5189 1 14.6048 1 13.6154V6.38455C1 5.39525 1.52778 4.48108 2.38456 3.98643L8.64669 0.370991ZM10.6606 1.67906C10.2711 1.45422 9.79129 1.45422 9.4019 1.67906L3.13977 5.2945C2.75033 5.51934 2.51043 5.93487 2.51043 6.38455V13.6154C2.51043 14.0652 2.75033 14.4806 3.13977 14.7055L9.4019 18.3209C9.79129 18.5458 10.2711 18.5458 10.6606 18.3209L16.9227 14.7055C17.3121 14.4806 17.5521 14.0652 17.5521 13.6154V6.38455C17.5521 5.93487 17.3121 5.51934 16.9227 5.2945L10.6606 1.67906Z",
			fill: "currentColor"
		})
	]
});
export default SvgCriticalWarning;
